import { api, toCamelCase, toSnakeCase } from '../lib/api'
import { Client, ClientCreate, ClientUpdate } from '../types/client'

export const clientApi = {
  async getAll(): Promise<Client[]> {
    const response = await api.get('/clients')
    return response.data.map((item: unknown) =>
      toCamelCase(item as Record<string, unknown>) as unknown as Client
    )
  },

  async getById(id: number): Promise<Client> {
    const response = await api.get(`/clients/${id}`)
    return toCamelCase(response.data as Record<string, unknown>) as unknown as Client
  },

  async search(query: string): Promise<Client[]> {
    const response = await api.get(`/clients/search?q=${encodeURIComponent(query)}`)
    return response.data.map((item: unknown) =>
      toCamelCase(item as Record<string, unknown>) as unknown as Client
    )
  },

  async create(data: ClientCreate): Promise<Client> {
    const payload = toSnakeCase(data as unknown as Record<string, unknown>)
    const response = await api.post('/clients', payload)
    return toCamelCase(response.data as Record<string, unknown>) as unknown as Client
  },

  async update(id: number, data: ClientUpdate): Promise<Client> {
    const payload = toSnakeCase(data as unknown as Record<string, unknown>)
    const response = await api.put(`/clients/${id}`, payload)
    return toCamelCase(response.data as Record<string, unknown>) as unknown as Client
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/clients/${id}`)
  },

  async setDefault(id: number): Promise<Client> {
    const response = await api.put(`/clients/${id}/default`)
    return toCamelCase(response.data as Record<string, unknown>) as unknown as Client
  },
}
